export const PRIMARY_COLOR = "#5c3e2b";
export const SECONDARY_COLOR = "#d0b000";